export enum LandingAgeRequirement {
  Over18 = 'Over18',
  Over21 = 'Over21',
}

export enum LandingBackgroundType {
  Image = 'Image',
  Color = 'Color',
}

export enum LandingPoweredBy {
  MjPoints = 'MjPoints',
  Brand = 'Brand',
}

export enum LandingSocialNetwork {
  Instagram = 'Instagram',
  Facebook = 'Facebook',
  X = 'X',
  TikTok = 'TikTok',
  YouTube = 'YouTube',
  LinkedIn = 'LinkedIn',
  GoogleMaps = 'GoogleMaps',
  Weedmaps = 'Weedmaps',
  Leafly = 'Leafly',
}

/** Well-known registration fields. Custom fields carry an arbitrary `key`. */
export enum LandingFieldKey {
  FirstName = 'FirstName',
  LastName = 'LastName',
  Email = 'Email',
  PhoneNumber = 'PhoneNumber',
  RegistrationCode = 'RegistrationCode',
  DateOfBirth = 'DateOfBirth',
}

export interface LandingFormFieldDto {
  key: LandingFieldKey | string;
  label: string;
  visible: boolean;
  required: boolean;
  /** True for fields added via "Add Custom Field" (not one of LandingFieldKey). */
  custom: boolean;
}

export interface LandingSocialLinkDto {
  network: LandingSocialNetwork;
  url: string;
}

export interface LandingBrandDto {
  logoUrl: string | null;
  headline: string;
  description: string;
  primaryButtonText: string;
  secondaryLinkText: string | null;
  secondaryLinkUrl: string | null;
  /** URL opened from the "Program Details" item in the header burger menu. */
  programDetailsUrl: string | null;
}

export interface LandingSecurityDto {
  ageGateEnabled: boolean;
  ageRequirement: LandingAgeRequirement;
  captchaEnabled: boolean;
  termsUrl: string | null;
  termsLinkText: string;
  termsOpenInNewTab: boolean;
  privacyUrl: string | null;
  privacyLinkText: string;
  privacyOpenInNewTab: boolean;
}

export interface LandingDesignDto {
  backgroundType: LandingBackgroundType;
  backgroundImageUrl: string | null;
  backgroundColor: string;
}

export interface LandingTypographyDto {
  pageBackgroundColor: string;
  formBackgroundColor: string;
  primaryColor: string;
  buttonTextColor: string;
  headerColor: string;
  headlineColor: string;
  descriptionColor: string;
  textColor: string;
  labelColor: string;
  placeholderColor: string;
  borderColor: string;
  /** Text color for the footer (powered-by line and legal links). */
  footerTextColor: string;
  socialIconColor: string;
}

export interface LandingFooterDto {
  poweredBy: LandingPoweredBy;
  /** Custom brand name shown in the footer when poweredBy is Brand. */
  brandName: string | null;
  showSocialLinks: boolean;
  showTerms: boolean;
  showPrivacy: boolean;
  socialLinks: LandingSocialLinkDto[];
}

export interface LandingConfigDto {
  brand: LandingBrandDto;
  fields: LandingFormFieldDto[];
  security: LandingSecurityDto;
  design: LandingDesignDto;
  typography: LandingTypographyDto;
  footer: LandingFooterDto;
}

export interface LandingPageResponseDto {
  id: string;
  externalId: string;
  name: string;
  content: string | null;
  backgroundImage: string | null;
  logo: string | null;
  organizationId: string;
  isActive: boolean;
  createdBy: string | null;
  createdDate: string;
  updatedBy: string | null;
  updatedDate: string | null;
  brandId: string | null;
}
